export default __webpack_public_path__ + "static/logo-5a27474080b1acb30622dd29a6bf3b6f.svg";